import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Grid, CardContent } from '@material-ui/core';
import AddCircle from '@material-ui/icons/AddCircle';
import CheckCircle from '@material-ui/icons/CheckCircle';
import EditIcon from '@material-ui/icons/Edit';

import {
  ContentApproval,
  UserFeedFollowGroupFragment,
  useUpdateContentApprovalsMutation,
} from 'api';
import { IconLabelButton } from 'components';
import { useContent, useNotify } from 'hooks';
import { useRemoveContent } from 'features/content/updaters';

import { Date } from '../widgets';

interface IProps {
  selectedGroup: UserFeedFollowGroupFragment;
  showRemove: boolean;
}

const Approval: FC<IProps> = ({ showRemove, selectedGroup }) => {
  const notify = useNotify();
  const history = useHistory();
  const { t } = useTranslation();
  const { content_id, publish_at } = useContent();

  const approvalsMutationOptions = useRemoveContent();
  const { mutateAsync } = useUpdateContentApprovalsMutation(approvalsMutationOptions);

  function handleEdit() {
    return history.push(`/post/edit/${content_id}`);
  }

  async function handleApproval(approval: ContentApproval, i18nKey: string) {
    await mutateAsync({
      content_id,
      group_id_approvals: {
        approval,
        group_id: selectedGroup.id,
      },
    });

    notify.info({
      component: t(i18nKey),
    });
  }

  function renderButtons() {
    return (
      <Grid container spacing={2}>
        {showRemove && (
          <Grid item>
            <IconLabelButton
              icon={AddCircle}
              iconStyle={{ transform: 'rotate(45deg)' }}
              ButtonProps={{
                onClick: () => handleApproval(ContentApproval.Removed, 'content:postRemoved'),
              }}
              color="red"
            >
              {t('common:remove')}
            </IconLabelButton>
          </Grid>
        )}
        <Grid item>
          <IconLabelButton icon={EditIcon} ButtonProps={{ onClick: handleEdit }}>
            {t('common:edit')}
          </IconLabelButton>
        </Grid>
        <Grid item>
          <IconLabelButton
            icon={CheckCircle}
            ButtonProps={{
              onClick: () => handleApproval(ContentApproval.Approved, 'content:postApproved'),
            }}
          >
            {t('common:approve')}
          </IconLabelButton>
        </Grid>
      </Grid>
    );
  }

  return (
    <CardContent>
      <Grid container alignItems="center" justify="space-between">
        <Grid item xs>
          <Date contentId={content_id} publishAt={publish_at} />
        </Grid>
        <Grid item>{renderButtons()}</Grid>
      </Grid>
    </CardContent>
  );
};

export default Approval;
